export const getSidebarFooterStyles = () => ({
    container: {
        p: 2,
        textAlign: 'center'
    }
});